// extracted by mini-css-extract-plugin
export default {"listItem":"index_listItem__ec4Xs","label":"index_label__eoGuH","content":"index_content__dnST-"};